import { Divider, Tab, Tabs, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import React, { useEffect, useRef, useState } from "react";

export const FeatureLayerGroup = ({ layerFeatures }) => {
  const { t, i18n } = useTranslation("main");
  const [selectedLayerTab, setSelectedLayerTab] = useState(0);
  const selectedLayer = layerFeatures?.[selectedLayerTab];

  const [selectedFeatureTab, setSelectedFeatureTab] = useState(0);
  const selectedFeature = selectedLayer?.props.feature?.[selectedFeatureTab];

  const tableRef = useRef(null);
  const [gridStatus, setGridStatus] = useState();
  const isMobile = window.innerWidth < 960;
  const isRotated = window.innerWidth > window.innerHeight;

  useEffect(() => {
    if (
      !gridStatus &&
      selectedLayer.layer_type === "GRID" &&
      selectedLayer.properties.status
    )
      setGridStatus(selectedLayer.properties.status);
  }, [selectedLayerTab]);

  const handleChangeLayer = (_, newValue) => {
    setSelectedLayerTab(newValue);
  };

  const handleChangeFeature = (_, newValue) => {
    setSelectedFeatureTab(newValue);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          marginTop: "0.5rem",
        }}
      >
        <Typography style={{ fontWeight: "bold" }}>{t("layers")}:</Typography>
        <Tabs
          variant="scrollable"
          value={selectedLayerTab}
          onChange={handleChangeLayer}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: "var(--color-primary)",
            },
          }}
        >
          {layerFeatures.map((feature, index) => {
            return (
              <Tab
                key={index}
                label={feature.props.feature[0].layer_name?.[i18n.language]}
                value={index}
              />
            );
          })}
        </Tabs>
      </div>
      <Divider />

      {selectedLayer.props.feature.length > 1 && (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              marginTop: "0.5rem",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              {t("features")}:
            </Typography>
            <Tabs
              variant="scrollable"
              value={selectedFeatureTab}
              onChange={handleChangeFeature}
              aria-label="basic tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "var(--color-primary)",
                },
              }}
            >
              {selectedLayer.props.feature.map((feature, index) => {
                console.log("MAP feature", feature);
                return (
                  <Tab
                    key={index}
                    label={t(feature?.properties?.element_type ?? index + 1)}
                    value={index}
                  />
                );
              })}
            </Tabs>
          </div>
          <Divider />
        </>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          padding: "0 1rem",
          overflow: isMobile && isRotated ? "visible" : "auto",
          alignItems: "center",
          marginTop: "1rem",
          position: "relative",
        }}
        ref={tableRef}
        key={selectedFeatureTab}
      >
        {React.cloneElement(selectedLayer, { tableRef, selectedFeatureTab })}
      </div>
    </>
  );
};
